import { useLocalStorage } from 'usehooks-ts'

import FlagOutlinedIcon from '@ant-design/icons/FlagOutlined'

import { useTheme } from '@mui/material/styles'

export function useEntityFlagState(entity, id) {
  const [flags, updateFlags] = useLocalStorage(`${entity}-flags`, {})
  return [flags?.[id] || false, updateFlags]
}

export default function EntityFlag({ value }) {
  const theme = useTheme()

  return (
    <FlagOutlinedIcon
      style={{
        color: theme.palette.error.main,
        opacity: value ? 1 : 0,
        pointerEvents: value ? 'auto' : 'none',
        transition: 'opacity 225ms ease',
      }}
    />
  )
}
